export default {
  '切换语言成功':'한글 버전으로 전환하였습니다',
  '面单打印':'운송장 출력',
'批次管理':'항차관리',
'批次列表':'항차 일자',
'运单管理':'배송 관리',
'运单列表':'배송 목록',
'清单审核':'적하 체크',
'报关清关':'적하 신고',
'清单物流详情':'배송상태',
'系统管理':'시스템 관리',
'号段维护':'송장 관리',
'菜单权限管理':'권한관리',
'批量打单':'대량 출력',
'搜索':'조회',
'导出':'다운로드',
'导入':'업로드',
'详情':'상세내역',
'打单':'송장 출력',
'修改记录':'수정 기록',
'添加':'추가',
'生成提单':'비엘/마스터빌 발급',
'指定关税师':'관세사 지정',
'下载PDF':'PDF다운로드',
'添加子菜单':'메뉴 추가',
'编辑':'수정',
'关闭':'닫기',
'确定':'확인',
'取消':'취소',
'确 定':'확인',
'取 消':'취소',
'提示':'힌트',
'删除不可恢复，是否确定删除？':'삭제를 복구할 수 없습니다. 삭제하시겠습니까?',
'角色权限':'권한 설정',
'序号':'순서',
'导入时间':'업로드 시간 ',
'出库状态':'출고상태',
'打单状态':'출력상태',
'客户名':'고객명',
'快递单号':'운송장번호',
'客户翻译名':'고객명(영어)',
'收件人名字':'수하인 이름',
'收件人地址':'수하인 주소',
'中文品名':'품명(중국어)',
'商品名':'품명',
'C/T(包裹件数)':'C/T(포장개수)',
'Pieces Unit(商品数量)':'Pieces Unit(상품수량)',
'W/T（实际重量）':'W/T(중량)',
'Volume（体积）':'Volume(용적)',
'长':'길이',
'宽':'넓이',
'高':'높이',
'Value(US$)（价格）':'Value(US$)(달러금액)',
'类型(1个人,2公司,3特殊)':'용도구분(1-개인,2-회사,3-목록배제)',
'收件人电话号码':'수하인 전화번호',
'清关公司符号':'특송업체 코드',
'收件人邮编':'수하인 우편번호',
'交易类型':'거래구분 A.전자상거래 물품, D.개인 일반물품, E.상용견품, F.상업서류？ ',
'海关的hs代码':'HS CODE(6자리)',
'总数量':'총수량',
'韩国个人通关号码/营业执照':'개인통관고유부호/사업자 등록번호',
'发件人电话号码':'보내는분 전화번호',
'韩文收件人名称':'수하인 한글명',
'韩文收件地址':'수하인 한글주소',
'备注':'비고',
'商品详情':'상품에대한 종류',
'详细商品名称':'상세물품의 품명',
'分类':'구분',
'产品数量':'상품 수량',
'件数':'건수',
'重量':'무게',
'体积':'볼륨',
'订单号':'주문 번호',
'单位':'단위',
'产品价格':'상품 금액',
'条码':'바코드',
'小计':'소계',
'运输方式':'운송방식',
'海运':'해운',
'空运':'항공',
'出港时间':'출항일',
'预计到达日期':'예정 입항일',
'船运公司名称':'선사/항공사',
'航班航次':'선박항차/항공편명',
'提单凭证':'비엘/마스터빌',
'船运公司名称简称':'선사/항공사 약칭',
'出发地':'적재항',
'到达地':'양륙항',
'清单修改截止时间':'리스트 마감시간',
'发货点':'발송지',
'海关代码':'세관코드',
'到达地':'도착지',
'中国代码':'발송국가코드',
'韩国代码':'도착국가코드',
'购买网址':'전자상거래 홈페이지 URL주소',
'是否京东到付':'화물(경동) 착불여부',
'是否FTA代缴':'FTA관부가세 대납여부',
'分单号':'멀티송장번호',
'审核状态':'통관심사상태',
'关税师':'관세사',
'中国报关':'중국수출신고',
'韩国清关':'한국수입신고',
'海关状态':'진행상태',
'未通关理由':'미반출 사유',
'派送物流':'택배사',
'派送状态':'상품상태 확인',
'新快递单号':'추가 운송장번호',
'新物流公司':'추가 택배사',
'新费用':'추가 운임비',
'快递公司':'택배사',
'海关备注':'세관 비고',
'号段维护':'송장권역대 관리',
'操作':'작업',
'修改':'수정',
'删除':'삭제',
'共x条':'총x건',
'x条/页':'x건/페이지',
'xxx至xxx':'xxx T0 xxx',
'超过清单修改截止时间':'리스트 수정이 마감되었습니다',
'操作成功':'접수확정',
'参数有误':'정보오류',
'请上传文件':'엑셀파일 업로드해주세요',
'第x行数据运单号为空':'x번째줄 운동송번호 비워 있습니다 ',
'第x行数据运单号x已被其他卖家使用':'x번째줄 운동송번호x 사용중입니다',
'第x行数据运单号x已使用':'x번째줄 운동송번호x 사용중입니다',
'第x行数据运单号x已出库':'x번째줄 운동송번호x 이미 출고했습니다',
'x不能为空':'x는 비워둘 수 없습니다',
'是否京东到付必填是/否':'화물/경동 착불여부(착불/선불 필수)',
'是否FTA代缴必填是/否':'FTA관부가세 대납여부',
'发货人名字不能少于5位数':'화주명 최소5자입니다',
'海关禁止用的英文商品名':'수입금지 품목',
'收件人电话不能为010-000-0000':'010-000-0000 전화번호 오류',
'邮编必须为5位数，不能有（）':'우편번호 5자리이며,괄호() 필요없습니다',
'HS代码为6位数':'HS코드 6자리필수',
'同一个通关号码存在x个可能需要缴税':'공급자로부터 2건 이상의 물품이 반입되는 경우 과세될 수도 있습니다',
'金额超过150需要缴税':'150달러 초과했습니다',
'审核通过':'OK',
'审核未通过':'감사 미통과',
'已提单':'비엘/마스터빌 발급되었습니다',
'指定失败':'용도구분 접수실패',
'指定成功':'용도구분 접수확정',
'生成失败':'비엘/마스터빌 발급실패',
'生成成功,生成数量*':'비엘/마스터빌 *개 발급되었습니다.',
'删除失败':'삭제 실패',
'删除成功':'삭제되었습니다',
'物流清单':'택배사 리스트',
'导出失败':'다운로드 실패',
'海运中国报关':'해운 중국수출신고',
'空运中国报关':'항공 중국수출신고',
'海运韩国清关':'해운 한국수입신고',
'空运韩国清关':'항공 한국수입신고',
'请输入':'입력하십시오',
'不能为空':'는 비워둘 수 없습니다',
'配送详情':'배송상태',
'C/T(包裹件数)':'C/T(포장개수)',
'Pieces Unit(商品数量)':'Pieces Unit(상품수량)',
'W/T（重量）':'W/T(중량)',
'Value(US$)(美金价格)':'Value(US$)(달러금액)',
'类型(1-个人,2-企业,3-简易)':'용도구분(1-개인,2-회사,3-목록배제)',
'商品HS代码(6位数)':'HS CODE(6자리)',
'产品美金价格':'상품 금액',
'条形码':'바코드',
'海关编码':'HS CODE(6자리)',
'中文':'中文',
'韩文':'한국어',
'英文':'English',
'材质':'소재',
'拼音':'병음',
'全拼':'全拼',
'航班批次':'선박항차/항공편명',
'财务管理':'재무관리',
'费用':'배송비',
'首重费':'기본료',
'续重费':'무게 할증료',
'服务费':'서비스',
'包装费':'포장비용',
'配件费':'부품추가비',
'拍照':'사진요청',
'拍视频':'동영상요청',
'木架':'프레임 포장',
'特殊包装':'보완포장',
'体积费':'부피할증료',
'远程费':'도서산간',
'大件费':'화물비용',
'简易通关':'간이통관비',
'海关仓储':'세관보관료',
'短信费用':'메시지 전송',
'通关号转客服':'통관부호 서비스',
'国内退货':'현지반품',
'韩国回收费用':'한국창고 회수비용',
'回收单号':'회수 송장번호',
'二次发货单号':'한국창고 재배송송장',
'二次发货费用':'한국창고 재배송비용',
'其他':'기타',
'韩国仓储（保管月数*费用）':'한국창고 보관료(보관기간*기본료)',
'下载打单插件':'송장출력APP 다운로드',
'产品分类':'상품 카테고리',
'产品条码':'상품 코드',
'用户名':'셀러명',
'密码':'비밀번호',
'登录':'로그인',
'退出登录':'로그아웃',
'用户不存在':'아이디 존재하지 않습니다',
'密码错误':'아이디 또는 비밀번호를 잘못 입력했습니다.입력하신 내용을 다시 확인해주세요.',
'登录成功':'로그인 되었습니다',
'登录失败':'로그인이 실패했습니다',
'系统首页':'홈',
'信息修改':'정보수정',
'头像':'프로필사진',
'旧密码':'현재 비밀번호',
'新密码':'새 비밀번호',
'上次登录时间':'최근 로그인 시간',
'系统管理':'시스템관리',
'特殊品名库':'금지 품명목록',
'名称':'품명',
'韩国商品规则':'아이템 관리(KR)',
'原名称':'현재 품명',
'新名称':'새 품명',
'号段维护':'송장권역대 관리',
'快递公司':'택배사',
'号段':'송장권역대',
'中国商品规则':'아이템 관리(CH)',
'超级管理员':'슈퍼 관리자',
'超级管理员拥有所有权限 这个角色是由系统定的，不要更改':'슈퍼관리자는 모든 한권을 갖춥니다.',
'系统固定角色不要更改':'시스템 역할 변경하지 마세요',
'管理员':'관리자',
'国内物流':'중국 택배사',
'国内物流代理':'중국 택배대리',
'跨境电商卖家':'셀러',
'韩国物流':'한국 택배사',
'韩国关税师':'한국 관세사',
'只能看到23的件，申报价格超过150美金的。':'',
'京东货物快递':'화물 택배송장',
'CJ 不拿走的大件 由京东派送':'화물는 경동이나 대신택배로 넘어간 건에 따로 청구됩니다',
'发件人姓名':'보내는분',
'发件人电话':'전화번호',
'发件人地址':'주소',
'面单隐藏号码':'面单隐藏号码',
'所属角色':'역할',
'韩进备注':'한진택배 비고',
'韩进号段':'한진택배 송장권역대',
'CJ备注':'CJ비고',
'CJ号段':'CJ 송장권역대',
'菜单列表':'메뉴',
'角色列表':'역할목록',
'用户列表':'사용자목록',
'真实姓名':'실명',
'用户名(用于登陆)':'사용자(업로드용)',
'密码重置':'비밀번호 재설정',
'真实姓名':'실명',
'密码错误,超过5次账号将被冻结':'비밀번호 오류,5회 오류 시 계정이 동결됩니다',
'账号已被冻结':'계정이 동결되었습니다',
'角色':'역할',
'角色名称':'역할 이름',
'角色描述':'역할 설명',
'权限修改':'권한 수정',
'路由':'라우팅',
'排序':'정렬',
'图标':'아이콘',
'导入订单文件':'주문 파일 가져오기',
'订单文件':'주문 파일',
'将文件拖到此处，或':'파일을 여기로 드래그하거나',
'点击上传':'업로드 클릭',
'只能上传xlsx文件，且不超过50Mb':'xlsx 파일만 업로드할 수 있으며 50Mb를 초과하지 않습니다.',
'下载模板':'템플릿 다운로드',
'导入开始日期':'가져오기 시작 날짜',
'导入结束日期':'가져오기 종료 날짜',
'请选择':'선택하십시오',
'日期':'날짜',
'导入账单文件':'청구 파일 가져오기',
'账单文件':'청구서 파일',
'logisguide':'로지스가이드',
'海运模板':'해운 템플릿',
'空运模板':'항공 운송 템플릿',
'冻结账号':'계정 동결',
'冻结':'동결',
'正常':'정상',
'数量':'수량',
'价格':'가격',
'提示信息':'힌트',
'货架管理':'선반 관리',
'商标权':'지재권',
'电磁波':'전파법',
'品名异常':'품명상의',
'食品检疫':'식물검역',
'武器':'무기',
'麻药':'마약',
'药物法':'약사법',
'kc认证':'요건',
'其它':'기타',
'问题件':'문제',
'通关件': '통관완료',
'未通关件': '미통관',
'货架位置':'진열대 위치',
'转大件':'대형화물택대',
'收件人电话':'수하인 전화번호',
'图片':'사진',
'预付':'현택',
'到付':'착택',
'CJ账单':'CJ 청구서',
'港杂拖车':'항만 잡비 견인비',
'转发订单':'주문 전달',
'账单汇总':'계산서 요약',
'未派送':'배송되지 않음',
'开始派送':'배송 시작',
'已签收':'서명됨',
'追加费':'할증운임',
'快递费':'배송운임',
'偏远地区追加费':'도서운임',  
'已下架处理':'반출처리중',
'转发快递':'화물택대',

'配送日期':'배송완료일자',
'总运费':'합계운임',

  route: {
    dashboard: 'Dashboard',
    documentation: 'Documentation',
    guide: 'Guide',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    rolePermission: 'Role Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    dndList: 'Dnd List',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: 'Mixin',
    backToTop: 'Back To Top',
    dragDialog: 'Drag Dialog',
    dragSelect: 'Drag Select',
    dragKanban: 'Drag Kanban',
    charts: 'Charts',
    keyboardChart: 'Keyboard Chart',
    lineChart: 'Line Chart',
    mixChart: 'Mix Chart',
    example: 'Example',
    nested: 'Nested Routes',
    menu1: 'Menu 1',
    'menu1-1': 'Menu 1-1',
    'menu1-2': 'Menu 1-2',
    'menu1-2-1': 'Menu 1-2-1',
    'menu1-2-2': 'Menu 1-2-2',
    'menu1-3': 'Menu 1-3',
    menu2: 'Menu 2',
    Table: 'Table',
    dynamicTable: 'Dynamic Table',
    dragTable: 'Drag Table',
    inlineEditTable: 'Inline Edit',
    complexTable: 'Complex Table',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    mergeHeader: 'Merge Header',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    externalLink: 'External Link',
    profile: 'Profile'
  },
  navbar: {
    dashboard: 'Dashboard',
    github: 'Github',
    logOut: 'Log Out',
    profile: 'Profile',
    theme: 'Theme',
    size: 'Global Size'
  },
  login: {
    title: 'Login Form',
    logIn: 'Login',
    username: 'Username',
    password: 'Password',
    any: 'any',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  documentation: {
    documentation: 'Documentation',
    github: 'Github Repository'
  },
  permission: {
    addRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips: 'Rich text is a core feature of the management backend, but at the same time it is a place with lots of pits. In the process of selecting rich texts, I also took a lot of detours. The common rich texts on the market have been basically used, and I finally chose Tinymce. See the more detailed rich text comparison and introduction.',
    dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    importance: 'Imp',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
  example: {
    warning: 'Creating and editing pages cannot be cached by keep-alive because keep-alive include does not currently support caching based on routes, so it is currently cached based on component name. If you want to achieve a similar caching effect, you can use a browser caching scheme such as localStorage. Or do not use keep-alive include to cache all pages directly. See details'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name (default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name (default file)'
  },
  pdf: {
    tips: 'Here we use window.print() to implement the feature of downloading PDF.'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    tagsView: 'Open Tags-View',
    fixedHeader: 'Fixed Header',
    sidebarLogo: 'Sidebar Logo'
  }
}



// WEBPACK FOOTER //
// ./src/lang/ko.js